import { Entidad } from "../../../data/Entidad";
import { DataModuloMain } from "../../../data/ModuloMain";
import _L from "../../../util/Labels";

export namespace UIUtilViewFinanzaEgresoCategoria {
    export const _ID_EGRESO_GENERAL = 0;

    export function _CategoriaNombre(idCategoria: number): string {
        return (idCategoria == 0
            ? _L("general.general")
            : (DataModuloMain._GetDataValueFieldByName("EgresoCategoria", idCategoria, "Nombre") || _L("general.nodisponible")))
    }

    /** returns
    * `[item_general, ...(categorias || categorias_escuela)]`
    */
    export function _GetCategoriasFullList(idEscuela?: number): Entidad.IFinanzasEgresoCategoria[] {
        const idEgresoGeneral = UIUtilViewFinanzaEgresoCategoria._ID_EGRESO_GENERAL;
        const generalItem: Partial<Entidad.IFinanzasEgresoCategoria> = { Id: idEgresoGeneral, Nombre: _L("general.general") };
        const datos: Entidad.IFinanzasEgresoCategoria[] = [
            generalItem as any,
            ...DataModuloMain._GetReqDataArrayByName("EgresoCategoria", true)
        ]
        if (!idEscuela) {
            return datos;
        }
        return datos.filter(d => (d.Id == idEgresoGeneral || d.IdEscuela == idEscuela));
    }
}
